import { useCallback, useState } from 'react'

// names of the modals being used
export const MODALS = {
  RESET_PASSWORD: 'RESET_PASSWORD',
  UNBLOCK_SIGNIN: 'UNBLOCK_SIGNIN',
  BLOCK_SIGNIN: 'BLOCK_SIGNIN',
  REVOKE_SESSIONS: 'REVOKE_SESSIONS',
}

// types of actions of the buttons
export const ACTIONS = {
  RESET_PASSWORD: 'RESET_PASSWORD',
  BLOCK_SIGNIN: 'BLOCK_SIGNIN',
  UNBLOCK_SIGNIN: 'UNBLOCK_SIGNIN',
  SIGNOUT_OF_ALL_APPS: 'SIGNOUT_OF_ALL_APPS',
}

export const ACTION_TO_MODAL = {
  [ACTIONS.RESET_PASSWORD]: {
    modal: MODALS.RESET_PASSWORD,
    data: {},
  },
  [ACTIONS.BLOCK_SIGNIN]: {
    modal: MODALS.BLOCK_SIGNIN,
    data: {},
  },
  [ACTIONS.UNBLOCK_SIGNIN]: {
    modal: MODALS.UNBLOCK_SIGNIN,
    data: {},
  },
  [ACTIONS.SIGNOUT_OF_ALL_APPS]: {
    modal: MODALS.REVOKE_SESSIONS,
    data: {},
  },
}

const useIntegrationModals = () => {
  const [openedModal, setOpenedModal] = useState(null)
  const [modalData, setModalData] = useState({})

  const openIntegrationModal = useCallback((action) => {
    setOpenedModal(ACTION_TO_MODAL[action]?.modal)
    setModalData(ACTION_TO_MODAL[action]?.data)
  }, [])

  const closeIntegrationModal = useCallback(() => {
    setOpenedModal(null)
    setModalData({})
  }, [])

  return {
    openedModal,
    modalData,
    openIntegrationModal,
    closeIntegrationModal,
  }
}

export default useIntegrationModals
